<script>
function isValidHTML(html) {
    const tagPattern = /<\/?([a-zA-Z0-9]+)[^>]*>/g;
    const stack = [];
    let match;

    while ((match = tagPattern.exec(html)) !== null) {
        const tag = match[0];
        const tagName = match[1];
        if (tag[1] === '/') {
            const lastTag = stack.pop();
            if (lastTag !== tagName) {
                return { invalid: `Mismatched closing tag for ${tagName}, expected ${lastTag}` };
            }
        } else if (!tag.endsWith('/>')) {
            stack.push(tagName);
        }
    }

    if (stack.length > 0) {
        return { invalid: `Unclosed tag(s): ${stack.join(', ')}` };
    }

    return { valid: true };
}

import VRuntimeTemplate from "vue3-runtime-template";

export default {
    props: {
        template: {
            type: String,
        },
        parent: {
            type: Object,
        }
    },
    template: `<v-runtime-template :parent="actualParent" :template="actualTemplate"/>`,
    watch: {
        actualTemplate:{
            immediate:true,
            async handler() {
                // this ensures javascript doesn't blow up
                // if someone writes some bad code
                await this.$nextTick();
            },      
        }
    },
    computed: {
        actualParent() {
            return this.parent || this.$parent;
        },
        actualTemplate() {
            let html = this.template || '';

            html = html.replaceAll ? html.replaceAll('<br>', '<br/>') : html;

            var { valid, invalid } = isValidHTML(html);

            if (valid) {
                //Valid HTML
            } else {
                console.log('Invalid html', html)
                html = `<div>Invalid HTML. <pre>${invalid}</pre></div>`;
            }

            return html;
        }
    },
    components: {
        VRuntimeTemplate,
    }
};


</script>